
import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './RegisterPagePop.module.css';

import pageStylePops from './pageStylePops.module.css';


import ConnUrls from '../Connections/ConnectURL';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import MyFunctions from '../Functions/MyFunctions';
import { Checkbox } from '@mui/material';
import utilsCodes from '../Connections/_Utils/utilsCodes';
import PopUpClearComp from './PopUpClearComp';
import ConnectCodeCheck from './ConnectCodeCheck';
import RegisterCodeCheck from './RegisterCodeCheck';

const RegisterPagePop = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot] = useContext(MobiOrNotContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();


    const [phoneNum, setPhoneNum] = useState("");
    const [email, setEmail] = useState("");
    const [erMsg, setErMsg] = useState("")
    const [fName, setFName] = useState("");
    const [lName, setLName] = useState("");
    const [readIt, setReadIt] = useState(false);
    const [thePopUp, setThePopUp] = useState();
    const [erMsgBack, setErMsgBack] = useState("");



    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : styles)
    }, [mobiOrNot]);

    useEffect(() => {


    }, [])

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("RegisterP")
            setPageDetails(pg);
            document.getElementById(`nameEnter`).focus();

        }
        getPageDetalis();

    }, [])

    let tryLoop = 1;
    const registerMe = async () => {
        tryLoop++;
        let validatoring = "";

        validatoring = (fName !== "" && fName.length > 2) ? "" : "יש להזין שם פרטי";
        validatoring += (lName !== "" && lName.length > 1) ? "" : "יש להזין שם משפחה";

        validatoring += MyFunctions.validPhone(phoneNum);
        validatoring += MyFunctions.validEmail(email);
        validatoring += !readIt ? "readIt" : "";

        if (validatoring === "") {
            let newUsr = { firstName: fName, lastName: lName, phone: phoneNum, email: email, password: "", readIt, tryLoop }
            let codeReply = await utilsCodes.createCodeNuser(newUsr);

            if (codeReply.errormsg != null) {
                setErMsgBack(codeReply.errormsg)
            }
            else {
                setThePopUp(
                    <PopUpClearComp BtnTxt={"סגור"}
                        title={"התחברות"}
                        btnFStyle={"fatInBtn"}
                        closePop={() => setThePopUp()}
                        parentCLose={() => props.parentCLose()}
                        theInsideComp={
                            <RegisterCodeCheck
                                codeReply={codeReply}
                                newUsr={newUsr}
                                phoneNum={phoneNum}
                                backFunc={true}
                                closeMeFuc={() => setThePopUp()}
                                parentCLose={() => props.parentCLose()}
                                shoTopStrp={(tf) => { }}
                                scrollToTop={(stUp) => { }}
                                connectWithNumber={() => { setThePopUp(); }}
                            />
                        } />)

            }
        }
        else {
            setErMsg(validatoring)

        }
    }


    return (
        <div className={`${pageStylePops.topPlace} regularPoint`}>
            {pageDetails && <>
                <div className={pageStylePops.topPlaceWrap}>

                    <div className={pageStylePops.TopImg}>
                        <img src={`${ConnUrls.servMediasUrl}${!mobiOrNot ? pageDetails.PageTopImage : pageDetails.PageTopImageMobi}`}
                            className={pageStylePops.TopImg} alt={pageDetails.pageName || "הרשמה"} />
                        <div className={pageStylePops.halfCircle}></div>
                    </div>

                </div>
                <div className={pageStylePops.contentPlaceWrap}>
                    <div className={currnetStyle.ContactsData}>
                        <div className={currnetStyle.contWrap}>
                            <input
                                id={"nameEnter"}
                                className={`${currnetStyle.GoSendData} ${erMsg.includes("שם פרטי") ? "errorInput" : ""}`}
                                placeholder={"שם פרטי"} value={fName}
                                onChange={(e) => setFName(e.target.value)}
                                label="שם פרטי" variant="filled"
                            />
                        </div>
                        <div className={currnetStyle.contWrap}>
                            <input className={`${currnetStyle.GoSendData} ${erMsg.includes("שם משפחה") ? "errorInput" : ""}`}
                                placeholder={"שם משפחה"} value={lName}
                                onChange={(e) => setLName(e.target.value)} label="שם משפחה" variant="filled" />
                        </div>
                        <div className={currnetStyle.contWrap}>
                            <input
                                className={`${currnetStyle.GoSendData} ${erMsg.includes("טלפון") ? "errorInput" : ""}`}
                                placeholder={"נייד (לקבלת SMS)"} value={phoneNum} onChange={(e) =>
                                    setPhoneNum(e.target.value)} label="נייד (לקבלת SMS)" variant="filled" />
                        </div>
                        <div className={currnetStyle.contWrap}>
                            <input
                                className={`${currnetStyle.GoSendData} ${erMsg.includes("מייל") ? "errorInput" : ""}`}
                                placeholder={"מייל"} value={email} onChange={(e) =>
                                    setEmail(e.target.value)} label="מייל" variant="filled" />
                        </div>
                        <div className={`${currnetStyle.readItChkWrap} ${(erMsg.includes("readIt") ? "errorInput" : "")}`} >
                            <Checkbox checked={readIt} onChange={() => setReadIt(readIt ? false : true)} className="chkBx onRight" />
                            <div className={`${currnetStyle.readItTxt} spacePaddingTop_5 onRight`}><span>קראתי ואני מסכים/ה לתנאי </span>
                                <a href={"/TAkanon"} target={"_blank"} className={"readItLink"}>התקנון</a></div>
                        </div>
                        <br />

                        <div className={currnetStyle.contWrap}>
                            <div className={`${pageStylePops.loginPageBtns} inColorWhite inBackBlue pointing`} onClick={() => registerMe()}>
                                <div>הרשם</div>
                            </div>
                            <div className={"fullRow errorLine bold"}>
                                <p className={"noMargin"}>
                                    {erMsgBack !== "" ? erMsgBack :
                                        erMsg !== "" ? "יש למלא את כל הפרטים המסומנים" : ""
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    {thePopUp}

                </div>
            </>
            }
        </div >


    );
}

export default RegisterPagePop;
